import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { testConfigNotification } from '../../docs-routes'

const WebhookNotificationInfo = () =>
  <div className='flex flex-col gap-4'>
    <div>
      <Header
        hasNoTopMargin
        rank={4}
      >
        Notifications Settings
      </Header>
      <Paragraph>
        <Color
          display='inline'
          variant='theme-description-text'
        >
          <br />
          Manage and customize email and webhook notifications for test configurations based on your preferences and requirements in the Test Configs <b>Advanced Settings</b> tab. Webhooks allow you to send notifications using HTTP apps, such as Slack or PagerDuty.
          <br />
          <br />
          1. <b>Specify notification types and recipients</b>: Specify who receives notifications (the recipients). Additionally, you can choose the types of notifications they receive, such as for failed, errored, cancelled, or passed tests.
          <br />
          2. <b>Trigger notifications</b>: Send notifications automatically when test configurations execute and meet the specified conditions (for example, tests fail or are cancelled).
          <br />
          3. <b>Enable/disable notifications</b>: Enable (turn on) or disable (turn off) notifications.
          <br />
          4. <b>Edit/delete notifications</b>: Manage notifications and edit or delete any specific notification.
          <br />
          5. <b>Account-level control</b>: (for DAI Admin users) Disable all notifications at an account level to stop all notifications. To enable or disable notifications on an account level, access notification settings under <b>System &gt; Settings &gt; Test config notifications</b>.
        </Color>
      </Paragraph>
    </div>
    <div>
      <LinkToDocusaurus path={testConfigNotification}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </div>
  </div>

export default WebhookNotificationInfo
